<template>
  <div class="herder">
    <div class="herder-title">
      <div>
        <img src="../../assets/logo.png" alt="" />
      </div>
      <span>{{ msg }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "herder",
  props: {
    msg: String,
  },
};
</script>
<style lang="less" scoped>
.herder {
  width: 100%;
  height: 10%;
  position: absolute;
  background-image: url("../../assets/bt.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  .herder-title {
    padding: 0 0.5vw;
    height: 50%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    div {
      width: 22%;
      height: 100%;
      display: flex;
      align-items: center;
      img {
        width: auto;
        height: auto;
      }
    }
    span {
      font-weight: 900;
      margin-left: 0.5vw;
      font-size: 1.2vw;
      color: #fff;
      letter-spacing: 0.3vw;
      white-space: nowrap;
    }
  }
}
</style>
